/**
 * Service Export Index
 * Centralizes all service exports for easier imports
 */

import localDbService from './localDbService';
import demoBrowserDbService from '../../online-demo/services/demoBrowserDbService';
import { isCloudDemoRuntime } from '../../shared/utils/publicDemoRuntime';

const IS_CLOUD_DEMO = isCloudDemoRuntime();
const dbService = IS_CLOUD_DEMO ? demoBrowserDbService : localDbService;

export { dbService };

export default {
  dbService,
};
